import { useEffect, useState } from "react";

interface SplashScreenProps {
    statusText?: string;
    onFinish?: () => void;
}

const SplashScreen = ({ statusText = "Serviz Hub is starting...", onFinish }: SplashScreenProps) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        return () => {
            // Small fade-out delay if needed
        };
    }, []);

    return (
        <div className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-500 bg-emerald-base ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div className="bg-noise" />

            {/* Fluid background blobs */}
            <div className="fluid-bg-container">
                <div className="fluid-blob blob-1" />
                <div className="fluid-blob blob-2" />
                <div className="fluid-blob blob-3" />
            </div>

            <div className="relative z-10 flex flex-col items-center animate-in fade-in zoom-in-95 duration-700">
                {/* Logo */}
                <div className="w-20 h-20 rounded-2xl glass-frozen flex items-center justify-center mb-4 shadow-xl">
                    <span className="text-4xl font-black text-emerald-accent tracking-tighter">SH</span>
                </div>

                <h2 className="text-xl font-bold text-foreground tracking-tight mb-2">Serviz Hub</h2>

                {/* Progress indicator */}
                <div className="mt-8 flex flex-col items-center gap-4">
                    <div className="flex gap-1.5">
                        <div className="w-2 h-2 bg-emerald-accent rounded-full animate-bounce [animation-delay:-0.3s]" />
                        <div className="w-2 h-2 bg-emerald-accent rounded-full animate-bounce [animation-delay:-0.15s]" />
                        <div className="w-2 h-2 bg-emerald-accent rounded-full animate-bounce" />
                    </div>
                    <p className="text-muted-foreground text-[10px] uppercase font-bold tracking-[0.2em]">
                        {statusText}
                    </p>
                </div>
            </div>

            {/* App Version Tag */}
            <div className="absolute bottom-8 left-0 right-0 text-center">
                <p className="text-muted-foreground text-[9px] font-medium tracking-widest">PREMIUM HOME SERVICES · v1.0</p>
            </div>
        </div>
    );
};

export default SplashScreen;
